// attribution.js — first-party UTM attribution capture.
//
// On landing, if the URL carries utm_* params (e.g. a visitor arriving from a
// Keelara social post), record source/medium/campaign once per session via
// POST /api/attribution. No cookies, no third-party scripts — privacy-friendly
// first-party attribution that powers the Ops-Console "visits by source/
// campaign" view and Jenny's weekly campaign optimization.

const SESSION_KEY = 'attr:sent';

// Keep keys clean + safe (they become DynamoDB key segments). Lowercase,
// alnum + . _ -, capped length.
function sanitize(value, max = 64) {
  return (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]/g, '')
    .slice(0, max);
}

export function trackAttribution() {
  try {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const source = sanitize(params.get('utm_source'));
    if (!source) return; // only record genuine campaign arrivals

    // Fire once per session so SPA reloads / route changes don't double-count.
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, '1');

    const body = JSON.stringify({
      source,
      medium: sanitize(params.get('utm_medium')) || 'unknown',
      campaign: sanitize(params.get('utm_campaign')) || 'none',
    });

    const url = '/api/attribution';
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* attribution must never block render */
  }
}
